import {Directive, ElementRef, Input} from '@angular/core';

const DANGEROUS_TAGS = 'script, object, embed, meta, link, base';

@Directive({
  selector: '[dcpInnerHtml]',
  standalone: true,
})
export class DcpInnerHtmlDirective {
  @Input({alias: 'dcpInnerHtml', required: true})
  set html(value: string | null | undefined) {
    this.el.nativeElement.innerHTML = DcpInnerHtmlDirective.clean(value ?? ''); // NOSONAR: content is pre-sanitized
  }

  constructor(private readonly el: ElementRef<HTMLElement>) {}

  // Strips dangerous nodes and event-handler attributes while preserving custom
  // elements that Angular's DomSanitizer would otherwise remove from innerHTML.
  static clean(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll(DANGEROUS_TAGS).forEach(el => el.remove());
    doc.body.querySelectorAll('*').forEach(el => {
      Array.from(el.attributes)
        .filter(attr => /^on/i.test(attr.name) || /^\s*javascript:/i.test(attr.value))
        .forEach(attr => el.removeAttribute(attr.name));
    });
    return doc.body.innerHTML;
  }
}
